import classNames from "classnames";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "../../components/Container/Container";
import { Expanded } from "../../components/Expanded/Expanded";
import { P } from "../../components/Paragraph/Paragraph";
import { Row } from "../../components/Row/Row";
import { ViewerMenu } from "../../components/ViewerMenu/ViewerMenu";
import { AdminViewParams, ADMIN_VIEW_PATH } from "../../routes";
import { buildUrl } from "../../services/buildUrl";
import { AdminViewProps } from "../../views/AdminView/AdminView";
import { FlexProps } from "../Flex/Flex";
import styles from "./AppHeader.module.scss";

export type AppHeaderProps = AdminViewProps & FlexProps;

export const AppHeader: React.FC<AppHeaderProps> = ({ viewer, className }) => {
  const navigate = useNavigate();

  return (
    <Row overflow className={classNames(styles.header, className)}>
      <Container
        mainAxisAlignment="center"
        className={styles.logo}
        onClick={() =>
          navigate({
            pathname: buildUrl<AdminViewParams>(ADMIN_VIEW_PATH, {}),
          })
        }
      >
        <P>MindSpa</P>
        <P tiny>CLEAR YOUR MIND</P>
      </Container>
      <Expanded />
      <ViewerMenu padLeft viewer={viewer} />
    </Row>
  );
};
